<!-- //
组件-echarts-bar
@auth xuyd
@date 2024-05-03
//-->
<template>
  <PropsWrapper :widgetProps="widgetProps">
    <el-form @submit.native.prevent class="form" :model="form" size="small" :label-width="this.dvContants.labelWidth">
      <el-form-item prop="width" label="宽度1">
        <el-input v-model="form.width" style="width: 100%" maxlength="6">
          <template slot="append">px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="height" label="高度2">
        <el-input v-model="form.height" style="width: 100%" maxlength="6">
          <template slot="append">px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="left" label="左边距3">
        <el-input v-model="form.left" style="width: 100%" maxlength="6">
          <template slot="append">px</template>
        </el-input>
      </el-form-item>
      <el-form-item prop="top" label="上边距4">
        <el-input v-model="form.top" style="width: 100%" maxlength="6">
          <template slot="append">px</template>
        </el-input>
      </el-form-item>
    </el-form>
  </PropsWrapper>
</template>

<script>

export default {
  name: 'WidgetEchartsBarForm',
  components: {},
  dictTypes: [],
  data() {
    return {
      form: this.widgetProps.viewProps,
    }
  },
  props: {
    widgetProps: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {},
  methods: {}
}
</script>

<style lang="less" scoped>
.ui-props {
}
</style>
